// import { TablePaginationConfig } from "antd";

const paginationConfig = {
  pageSize: 10,
};
export default paginationConfig;
